module.exports = __webpack_public_path__ + "img/svg/pizza-stats.819f73a8419f4bde22f1b0a6c002512f.svg";